import { combineReducers } from 'redux';
import user from './user';
import runtime from './runtime';
import intl from './intl';
import district from './district';
import postGeoData from './postGeoData';
import style from './style';
import powiaty from './powiaty';
import routing from './routing';
import layers from './layers';
import tools from './mapTools';
import printSettings from './printSettings';
import eservices from './eservices';
import gminy from './gminy';
import app from './app';

export default combineReducers({
  user,
  routing,
  layers,
  postGeoData,
  district,
  gminy,
  powiaty,
  runtime,
  intl,
  tools,
  style,
  printSettings,
  eservices,
  app,
});



// WEBPACK FOOTER //
// src/reducers/index.js